export default function getAppUserData() {
    return {
        uidSlave: localStorage.getItem('uidSlave'),
        userId: localStorage.getItem('userID'),
        username: localStorage.getItem('username'),
        role: localStorage.getItem('role'),
        selectedMainHotel: localStorage.getItem('selectedMainHotel'),
        selectedParityHotel: localStorage.getItem('selectedParityHotel'),
        mainHotelsSectionData: JSON.parse(localStorage.getItem('mainHotelsSectionsData')),
        features: JSON.parse(localStorage.getItem('features')),
        hasFtp: JSON.parse(localStorage.getItem('hasFTP')),
        email: localStorage.getItem('email'),
        lookerUrl: JSON.parse(localStorage.getItem('lookerUrl')),
        priceByNight: localStorage.getItem('priceByNight'),
    }
}
